import { render, staticRenderFns } from "./BatchSummary.vue?vue&type=template&id=121bf7a8&scoped=true&"
import script from "./BatchSummary.vue?vue&type=script&lang=js&"
export * from "./BatchSummary.vue?vue&type=script&lang=js&"
import style0 from "./BatchSummary.vue?vue&type=style&index=0&id=121bf7a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121bf7a8",
  null
  
)

export default component.exports